import { render, staticRenderFns } from "./paging.vue?vue&type=template&id=47ae4684&"
import script from "./paging.js?vue&type=script&lang=js&"
export * from "./paging.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\e-trailor\\Bont\\Frontend\\BontScheduler.Portal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47ae4684')) {
      api.createRecord('47ae4684', component.options)
    } else {
      api.reload('47ae4684', component.options)
    }
    module.hot.accept("./paging.vue?vue&type=template&id=47ae4684&", function () {
      api.rerender('47ae4684', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientApp/components/common/paging.vue"
export default component.exports